import type { IOrthOV1ProcedureProps } from './OrthOV1ProcedureRead';
import { HeaderDivider } from '../../../elements/common';
import { OrthOExaminationOrder } from './orthOExaminationOrder';
import { OrthOV1ProcedureCheckedVisusExaminationOdOsRow } from './OrthOV1ProcedureCheckedVisusExaminationOdOsRow';
import { anyExaminationFieldHasErrors, visus_ec_refraction_fields } from './OrthOV1ProcedureCheckedVisusExaminations';
import { ReadOrEditInputField } from './ReadOrEditInputField';

export function OrthOV1ProcedureAnamnese(props: IOrthOV1ProcedureProps) {
    return (
        <>
            <HeaderDivider text="Anamnese" />
            <ReadOrEditInputField
                {...props}
                error={
                    !props.isReadOnly && props.errors
                        ? props.errors.get('customControlData.klachten_en_of_reden_van_bezoek')
                        : ''
                }
                fieldKey="klachten_en_of_reden_van_bezoek"
                hasErrors={props.errors?.has('customControlData.klachten_en_of_reden_van_bezoek')}
                isRequired={true}
                label="orthOProcedure.complaints_and_or_reason_of_visit"
                placeholder="Bijvoorbeeld hoofdpijn, wazig of dubbel zien, moeite met scherpstellen..."
                tabIndex={OrthOExaminationOrder.anamnese}
                value={props.customControlData.klachten_en_of_reden_van_bezoek}
            />

            <ReadOrEditInputField
                {...props}
                error={
                    !props.isReadOnly && props.errors
                        ? props.errors.get('customControlData.algemene_gezondheid_en_medicatie')
                        : ''
                }
                fieldKey="algemene_gezondheid_en_medicatie"
                hasErrors={props.errors?.has('customControlData.algemene_gezondheid_en_medicatie')}
                isRequired={!props.isOrthOFol}
                label="orthOProcedure.general_health_and_medication"
                placeholder="Gezondheid, levensstijl en medicijngebruik..."
                tabIndex={OrthOExaminationOrder.anamnese}
                value={props.customControlData.algemene_gezondheid_en_medicatie}
            />

            <ReadOrEditInputField
                {...props}
                error={
                    !props.isReadOnly && props.errors
                        ? props.errors.get('customControlData.oculaire_voorgeschiedenis')
                        : ''
                }
                fieldKey="oculaire_voorgeschiedenis"
                hasErrors={props.errors?.has('customControlData.oculaire_voorgeschiedenis')}
                isRequired={!props.isOrthOFol}
                label="orthOProcedure.ocular_history"
                placeholder="Bijvoorbeeld bezoek oogarts, lenzen, bril..."
                tabIndex={OrthOExaminationOrder.anamnese}
                value={props.customControlData.oculaire_voorgeschiedenis}
            />

            <OrthOV1ProcedureCheckedVisusExaminationOdOsRow
                additie_od={props.customControlData.visus_ec_refractie_additie_od}
                additie_os={props.customControlData.visus_ec_refractie_additie_os}
                as_od={props.customControlData.visus_ec_refractie_as_od}
                as_os={props.customControlData.visus_ec_refractie_as_os}
                cylindrisch_od={props.customControlData.visus_ec_refractie_cylindrisch_od}
                cylindrisch_os={props.customControlData.visus_ec_refractie_cylindrisch_os}
                errors={props.isReadOnly ? undefined : props.errors}
                field="visus_ec_refractie"
                hasErrors={anyExaminationFieldHasErrors(visus_ec_refraction_fields, !!props.isReadOnly, props.errors)}
                isReadOnly={props.isReadOnly}
                label="Huidige brilsterkte"
                onDoValidate={props.validateOneCustomControl}
                prisma_degrees_od={props.customControlData.visus_ec_refractie_prisma_degrees_od}
                prisma_degrees_os={props.customControlData.visus_ec_refractie_prisma_degrees_os}
                prisma_od={props.customControlData.visus_ec_refractie_prisma_od}
                prisma_os={props.customControlData.visus_ec_refractie_prisma_os}
                sferisch_od={props.customControlData.visus_ec_refractie_sferisch_od}
                sferisch_os={props.customControlData.visus_ec_refractie_sferisch_os}
            />

            <ReadOrEditInputField
                {...props}
                error={
                    !props.isReadOnly && props.errors
                        ? props.errors.get('customControlData.familiaire_voorgeschiedenis')
                        : ''
                }
                fieldKey="familiaire_voorgeschiedenis"
                hasErrors={props.errors?.has('customControlData.familiaire_voorgeschiedenis')}
                isRequired={true}
                label="orthOProcedure.family_history"
                placeholder="Omschrijf de familiaire voorgeschiedenis..."
                tabIndex={OrthOExaminationOrder.anamneseFamilyHistory}
                value={props.customControlData.familiaire_voorgeschiedenis}
            />
        </>
    );
}
